import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';

import { BudgetService } from '../service/budget.service';
import { CashFlowService } from '../service/cashflow.service';
import { CompanyService } from '../service/company.service';
import { HomeService } from '../service/home.service';
import { LoanService } from '../service/loan.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { OtherService } from '../service/other.service';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
})
export default class SummaryComponent implements OnInit {
  constructor(
    private cashflowservice: CashFlowService,
    private operatingexpensesService: OperatingexpensesService,
    private otherService: OtherService,
    private homeService: HomeService,
    private loanService: LoanService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private route: ActivatedRoute,
    private router: Router,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    public fb: FormBuilder
  ) {
    this.toastr.setRootViewContainerRef(vRef);

    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.getProjectData();
    this.showInstructions = false;
    this.userName = new FormControl(this.userName, [
      Validators.maxLength(20),
      Validators.pattern(/^((?=.*[a-zA-Z])[A-Za-z-'_'\s]+)$/),
    ]);
    this.phone = new FormControl(this.phone);
    this.email = new FormControl(this.email, [
      Validators.pattern(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ),
    ]);
    this.comments = new FormControl(this.comments);

    this.form = this.fb.group({
      userName: this.userName,
      email: this.email,
      phone: this.phone,
      comments: this.comments,
    });
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Input() showSummary: boolean;

  @Output() summaryEmit: EventEmitter<any> = new EventEmitter();

  @Output() otherEmitSummary: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  form: FormGroup;

  projectId: string;

  companyId: string;

  projectName: string;

  companyLogoUrl = '';

  userName: FormControl = null;

  email: FormControl = null;

  phone: FormControl = null;

  comments: FormControl = null;

  totalProjectFunding: number;

  totalFunds: number;

  returnOnInvestment: number;

  minimumInvestment: number;

  term: number;

  otherTermArray: any = [];

  isEdit: boolean;

  // TEN YEAR RECORDS ARRAYS
  goiTenYearsData = [];

  payrollTenYearsData = [];

  payrollTenYearsDataGoi = [];

  generalTenYearsData = [];

  generalTenYearsDataGoi = [];

  opexTenYearsData = [];

  opexTenYearsDataGoi = [];

  netOperatingIncomeTenYearsData: any = [];

  debtServiceTenYearsData = [];

  netProfitTenYearsData = [];

  netProfitPercentTenYearsData = [];

  debtServiceMultipleTenYearsData = [];

  // TEN YEAR RECORDS ARRAYS FOR CUMULATIVE
  // Indexes into the XXXCumulative arrays
  readonly YEARS1TO3_INDEX = 0;

  readonly YEARS1TO5_INDEX = 1;

  readonly YEARS1TO7_INDEX = 2;

  readonly YEARS1TO10_INDEX = 3;

  goiDataCumulative: any = [];

  payrollDataCumulative: any = [];

  payrollDataGoiCumulative: any = [];

  generalDataCumulative: any = [];

  generalDataGoiCumulative: any = [];

  opexDataCumulative: any = [];

  opexDataGoiCumulative: any = [];

  netOperatingIncomeCumulative: any = [];

  debtServiceCumulative: any = [];

  netProfitCumulative: any = [];

  netProfitPercentCumulative: any = [];

  debtServiceCoverageCumulative: any = [];

  // VARIABLES FOR TOTAL OF TEN YEAR RECORDS
  tenYearsGoiTotal: number;

  tenYearsPayrollTotal: number;

  tenYearsPayrollGoiTotal: number;

  tenYearsGeneralTotal: number;

  tenYearsGeneralGoiTotal: number;

  tenYearsOpexTotal: number;

  tenYearsOpexGoiTotal: number;

  tenYearsNetOperatingIncomeTotal: number;

  tenYearsDebtServiceTotal: number;

  tenYearsNetProfitTotal: number;

  tenYearsNetProfitPercentTotal: number;

  tenYearsNetProfitPercentAverage: number;

  tenYearsDebtServiceCoverageTotal: number;

  tenYearsDebtServiceCoverageAverage: number;

  showInstructions: boolean;

  ngOnInit() {
    this.getCompanyData();
    this.getOtherFields();
    this.getOccupiedBedstenYearly();
  }

  // TO GET PROJECT DATA THROUGH PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.totalProjectFunding = Math.round(projectData.data[0].total_project_funding);
      this.totalFunds = Math.round(projectData.data[0].total_funds);
      if (this.totalProjectFunding === this.totalFunds || this.totalProjectFunding === 0) {
        this.totalProjectFunding = this.totalFunds;
      }
      this.returnOnInvestment = projectData.data[0].return_on_investment;
      this.minimumInvestment = projectData.data[0].minimum_investment;
      this.term = projectData.data[0].term;
      this.userName.setValue(projectData.data[0].user_name);
      this.email.setValue(projectData.data[0].email);
      this.phone.setValue(projectData.data[0].phone);
      this.comments.setValue(projectData.data[0].comments);
    });
  }

  // GET SAVED COMPANY LOGO FROM DB
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // SAVE EDITOR'S CONTENT ONCHANGE
  onContentChanged(event) {
    this.comments = event.html;
    const data = { fieldName: 'comments', value: this.comments };
    this.projectService.onChangeProject(this.projectId, data).subscribe(() => {
      // console.log("response comments",res);
    });
  }

  // UPDATE SUMMARY PAGE'S PARAMETERS FIELDS(INPUT FIELDS) ONCHANGE
  onUpdate(event) {
    const fieldName = event.target.name;
    const value = this.replaceDollarsCommasPercentages(event.target.value);
    // CHECK VALIDITY of fields with validations
    if (
      (fieldName === 'userName' && this.userName.invalid) ||
      (fieldName === 'email' && this.email.invalid)
    ) {
      if (fieldName === 'userName' && this.userName.invalid) {
        this.userName.setValue('');
      } else if (fieldName === 'email' && this.email.invalid) {
        this.email.setValue('');
      }
    } else {
      let data = {};
      if (fieldName === 'totalProjectFunding') {
        if (this.totalProjectFunding !== this.totalFunds && this.totalProjectFunding !== 0) {
          data = { fieldName, value };
        }
      } else {
        data = { fieldName, value };
      }
      this.projectService.onChangeProject(this.projectId, data).subscribe(
        (res) => {
          if (res.messageId === 200) {
          }
        },
        () => {
          this.toastr.error('Something is wrong!', 'Oops!');
        }
      );
    }
  }

  // ############## OTHER FIELDS TASKS #################//

  // UPDATE OTHER FIELDS
  updateOtherField(id, event, fieldName, nodeIndex) {
    if (fieldName === 'name') {
      const variableName = 'field_name';
      this.otherService
        .updateFieldNameValue(id, event.target.value, variableName)
        .subscribe(() => {});
    } else {  // if (fieldName === 'value') {
      const value = this.replaceDollarsCommasPercentages(event.target.value);
      const variableName = 'field_value';
      this.otherService.updateFieldNameValue(id, value, variableName).subscribe(() => {
        this.otherTermArray = [];
        this.getOtherFields().then(() => {
          setTimeout(function () {
            if (nodeIndex < this.otherTermArray.length - 1) {
              document.getElementById(`label${nodeIndex + 1}`).focus();
            }
          }, 100);
        });
      });
    }
  }

  // ADD OTHER FIELDS
  addInputField(parent, child) {
    const data = { projectId: this.projectId };
    let array = [];

    this.otherService.saveOtherField(parent, child, data).subscribe(
      () => {
        this.otherTermArray = [];
        this.getOtherFields().then(() => {
          if (child === 'term') {
            array = this.otherTermArray;
          }
          // SET FOCUS ON NEWLY ADDED FIELD
          setTimeout(() => {
            document.getElementById(`label${child}${array.length - 1}`).focus();
          }, 100);
        });
      },
      (err) => this.toastr.error(err.message, 'Error!')
    );
  }

  // GET OTHER FIELDS
  getOtherFields(): Promise<boolean> {
    return new Promise((resolve) => {
      this.otherService.getOtherFields(this.projectId, 'summary').subscribe((res) => {
        this.otherTermArray = [];
        for (const other of res.data) {
          if (other.child === 'term') {
            this.otherTermArray.push(other);
          }
        }
        resolve(true);
        this.otherEmitSummary.emit({ otherEmitSummary: true });
      });
    });
  }

  // REMOVE OTHER FIELDS
  removeOtherField(id, child) {
    let array = [];
    const data = { id, parent: 'summary' };
    this.otherService.removeOtherField(data).subscribe(() => {
      this.getOtherFields().then(() => {
        if (child === 'term') {
          array = this.otherTermArray;
        }
        // SET FOCUS ON NEXT OTHER AFTER DELETION FIELD
        setTimeout(() => {
          document.getElementById(`label${child}${array.length - 1}`).focus();
        }, 100);
      });
    });
  }
  // ************************END OD OTHER FIELDS TASKS  *********************/

  private static calculateCumulativeTotal(
    annualData: Array<number>,
    tenYearTotal: number | undefined
  ): Array<number> {
    const years1To3 = +annualData[0] + +annualData[1] + +annualData[2];
    const years1To5 = years1To3 + +annualData[3] + +annualData[4];
    const years1To7 = years1To5 + +annualData[5] + +annualData[6];
    const years1To10 = tenYearTotal || years1To7 + +annualData[7] + +annualData[8] + +annualData[9];

    const result = [years1To3, years1To5, years1To7, years1To10];
    return result;
  }

  private calculateCumulativePercentOfGoi(cumulativeData: Array<number>): Array<number> {
    const result = [];
    for (let idx = 0; idx <= this.YEARS1TO10_INDEX; idx += 1) {
      let percentOfGoi = (cumulativeData[idx] / this.goiDataCumulative[idx]) * 100;
      percentOfGoi = isFinite(percentOfGoi) ? percentOfGoi : 0;

      result.push(percentOfGoi);
    }

    return result;
  }

  // GET 10 YEARS TOTALS DATA FOR OPERATING EXPENSES YEARS TABLE
  getOccupiedBedstenYearly() {
    const { projectId } = this;
    const data = { projectId };

    this.operatingexpensesService.tenYearsRecords(data).subscribe((res) => {
      // EMPTY THE ARRAYS SO THAT THEY ARE NOT POPULATED WITH SAME DATA AS WE START CHANGING START UP MONTH STARTS HERE
      this.goiDataCumulative = [];
      this.payrollDataCumulative = [];
      this.payrollDataGoiCumulative = [];
      this.generalDataCumulative = [];
      this.generalDataGoiCumulative = [];
      this.opexDataCumulative = [];
      this.opexDataGoiCumulative = [];
      this.netOperatingIncomeCumulative = [];

      this.goiTenYearsData = [];
      this.payrollTenYearsData = [];
      this.payrollTenYearsDataGoi = [];
      this.generalTenYearsData = [];
      this.generalTenYearsDataGoi = [];
      this.opexTenYearsData = [];
      this.opexTenYearsDataGoi = [];
      this.netOperatingIncomeTenYearsData = [];
      this.debtServiceTenYearsData = [];
      this.netProfitTenYearsData = [];
      this.netProfitPercentTenYearsData = [];
      this.debtServiceMultipleTenYearsData = [];
      // EMPTY THE ARRAYS SO THAT THEY ARE NOT POPULATED WITH SAME DATA AS WE START CHANGING START UP MONTH ENDS HERE

      for (const yearData of res.data) {
        this.goiTenYearsData.push(Math.round(yearData.total_goi_year));
        this.payrollTenYearsData.push(Math.round(yearData.total_payroll_year));

        let goiValue = yearData.total_payroll_year_goi;
        this.payrollTenYearsDataGoi.push(goiValue);

        this.generalTenYearsData.push(Math.round(yearData.total_general_year));

        goiValue = yearData.total_general_year_goi;
        this.generalTenYearsDataGoi.push(goiValue);

        this.opexTenYearsData.push(Math.round(yearData.total_opex_year));

        this.debtServiceTenYearsData.push(yearData.annualDebtService);

        //
        // Net operating income (NOI) is just the GOI - total operating expenses. It does not have anything to do with debt service.
        // Net PROFIT, however, removes the debt service because you have to pay the loan distributions before you put the remaining
        // money in your pocket. We're calculating NOI here because it is used later in determining the Debt Service Coverage.
        //
        const annualNetOperatingIncome = yearData.total_goi_year - yearData.total_opex_year;
        const netProfit = annualNetOperatingIncome - yearData.annualDebtService;
        this.netProfitTenYearsData.push(netProfit);
        this.netProfitPercentTenYearsData.push(netProfit / goiValue);

        //
        // Calculate the debt service coverage as shown on the Financial Reports. It is just
        // the NOI / debt service (assuming debt service is not zero). We need this on an annual basis.
        //
        const debtServiceMultiple = annualNetOperatingIncome / yearData.annualDebtService;
        this.debtServiceMultipleTenYearsData.push(
          Number.isFinite(debtServiceMultiple) ? debtServiceMultiple : 0
        );

        // opexDataYearlyGoiTotal
        goiValue = yearData.total_opex_year_goi;
        this.opexTenYearsDataGoi.push(goiValue);

        this.netOperatingIncomeTenYearsData.push(Math.round(annualNetOperatingIncome));
      }

      this.tenYearsGoiTotal = this.goiTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsPayrollTotal = this.payrollTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsPayrollGoiTotal = this.payrollTenYearsDataGoi.reduce((a, b) => a + b, 0);

      this.tenYearsGeneralTotal = this.generalTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsGeneralGoiTotal = this.generalTenYearsDataGoi.reduce((a, b) => a + b, 0);

      this.tenYearsOpexTotal = this.opexTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsOpexGoiTotal = this.opexTenYearsDataGoi.reduce((a, b) => a + b, 0);

      this.tenYearsNetOperatingIncomeTotal = this.netOperatingIncomeTenYearsData.reduce(
        (a, b) => a + b,
        0
      );

      this.tenYearsOpexTotal = this.opexTenYearsData.reduce((a, b) => a + b, 0);

      this.tenYearsDebtServiceTotal = this.debtServiceTenYearsData.reduce((a, b) => a + b, 0);

      this.tenYearsNetProfitTotal = this.netProfitTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsNetProfitPercentTotal = this.tenYearsNetProfitTotal / this.tenYearsGoiTotal;
      this.tenYearsNetProfitPercentAverage =
        this.tenYearsNetProfitTotal / 10 / (this.tenYearsGoiTotal / 10);

      const tenYearsDebtServiceCoverageTotal =
        this.tenYearsNetOperatingIncomeTotal / this.tenYearsDebtServiceTotal;
      this.tenYearsDebtServiceCoverageTotal = Number.isFinite(tenYearsDebtServiceCoverageTotal)
        ? tenYearsDebtServiceCoverageTotal
        : 0;

      //
      // The Debt Service Coverage average is the NOI average (NOI total / 10 years) divided by the average debt service (tenYearsDebtServiceTotal / 10).
      // This mathematically reduces to just the same as the (NOI total / Debt Service total), so we can just reuse the value from
      // the Debt Service Coverage Total.
      //
      this.tenYearsDebtServiceCoverageAverage = this.tenYearsDebtServiceCoverageTotal;

      //
      // Calculate all of the values for the "Cumutative" table
      //
      this.goiDataCumulative = SummaryComponent.calculateCumulativeTotal(
        this.goiTenYearsData,
        this.tenYearsGoiTotal
      );
      this.payrollDataCumulative = SummaryComponent.calculateCumulativeTotal(
        this.payrollTenYearsData,
        this.tenYearsPayrollTotal
      );
      this.payrollDataGoiCumulative = this.calculateCumulativePercentOfGoi(
        this.payrollDataCumulative
      );
      this.generalDataCumulative = SummaryComponent.calculateCumulativeTotal(
        this.generalTenYearsData,
        this.tenYearsGeneralTotal
      );
      this.generalDataGoiCumulative = this.calculateCumulativePercentOfGoi(
        this.generalDataCumulative
      );
      this.opexDataCumulative = SummaryComponent.calculateCumulativeTotal(
        this.opexTenYearsData,
        this.tenYearsOpexTotal
      );
      this.opexDataGoiCumulative = this.calculateCumulativePercentOfGoi(this.opexDataCumulative);
      this.netOperatingIncomeCumulative = SummaryComponent.calculateCumulativeTotal(
        this.netOperatingIncomeTenYearsData,
        this.tenYearsNetOperatingIncomeTotal
      );
      this.debtServiceCumulative = SummaryComponent.calculateCumulativeTotal(
        this.debtServiceTenYearsData,
        undefined
      );
      this.netProfitCumulative = SummaryComponent.calculateCumulativeTotal(
        this.netProfitTenYearsData,
        undefined
      );

      //
      // Calculating the cumulative values for the Net Profit % and Debt Service Coverage have to be done off of the cumulative
      // arrays for the values that make up the calculations. We can't just add them up like all of the other fields.
      //
      for (let idx = 0; idx < this.netProfitCumulative.length; idx += 1) {
        this.netProfitPercentCumulative.push(
          this.netProfitCumulative[idx] / this.goiDataCumulative[idx]
        );
        this.debtServiceCoverageCumulative.push(
          this.netOperatingIncomeCumulative[idx] / this.debtServiceCumulative[idx]
        );
      }

      this.summaryEmit.emit({ summaryEmit: true });
    });
  }

  // REMOVE ALL , $ % . FROM THE VALUE ENTERED BY USER
  replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/summary/summary.component.ts